<!-- Hidden rather than removed while results show: removing it would lose the
     chosen range, and Edit search would reopen on the default preset. -->
<div class="compose-step" [hidden]="search() !== null">

  <!-- <mat-card class="lookup-card">
    <mat-card-header>
      <mat-card-title class="page-title">Download Certificate</mat-card-title>
      <mat-card-subtitle>Find vehicles processed by Privacy4Cars and download their data-deletion certificates.</mat-card-subtitle>
    </mat-card-header>

    <app-filter-bar hideDataFilters [maxRangeMonths]="maxRangeMonths" [presets]="presets">
      <div class="vin-search">
        <app-vin-input [(entries)]="draft" />
        <div class="vin-search-actions">
          <button mat-flat-button color="primary" [disabled]="!canSearch()" (click)="runSearch()">
            <mat-icon>search</mat-icon>
            Search
          </button>
          <button mat-stroked-button [disabled]="!draft().length" (click)="clear()">Clear</button>
        </div>
      </div>
    </app-filter-bar>
  </mat-card> -->

  <app-filter-bar hideDataFilters [maxRangeMonths]="maxRangeMonths" [presets]="presets">

    <div class="vin-search">
      <app-vin-input [(entries)]="draft" />
      <div class="vin-search-actions">
        <button mat-flat-button color="primary" [disabled]="!canSearch()" (click)="runSearch()">
          <mat-icon>search</mat-icon>
          Search
        </button>
        <button mat-stroked-button [disabled]="!draft().length" (click)="clear()">Clear</button>
      </div>
    </div>
    
  </app-filter-bar>

  <mat-card class="empty-state">
    <mat-icon class="empty-state-icon">manage_search</mat-icon>
    <p class="empty-state-title">Enter one or more VINs and a date range, then click Search</p>
    <p class="empty-state-text">Results will list each processed vehicle with its certificate.</p>
  </mat-card>

</div>

@if (search(); as current) {

  <mat-card class="search-summary">
    <mat-card-content>
      <span class="summary-label">VINs:</span>
      <mat-chip-set aria-label="Searched VINs">
        @for (vin of current.vins; track vin.value) {
          <mat-chip
            [class.vin-not-found]="notFound().has(vin.value)"
            [matTooltip]="notFound().has(vin.value) ? 'No processed vehicles found in this date range' : ''"
            (removed)="removeFromSearch(vin.value)">
            @if (notFound().has(vin.value)) {
              <mat-icon matChipAvatar>error_outline</mat-icon>
            }
            <span class="vin-value">{{ vin.value }}</span>
            <button matChipRemove [attr.aria-label]="'Remove ' + vin.value">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        }
      </mat-chip-set>
      <span class="summary-dates">
        Date: {{ formatDate(current.dateRange.start) }} – {{ formatDate(current.dateRange.end) }}
      </span>
      <button mat-stroked-button class="edit-search-btn" (click)="editSearch()">Edit search</button>
    </mat-card-content>
  </mat-card>

  <mat-card class="table-card">
    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title">Results</span>
        @if (!loading()) {
          <span class="results-count">
            {{ results().length }} {{ results().length === 1 ? 'record' : 'records' }} found
            · {{ selectable().length }} {{ selectable().length === 1 ? 'has' : 'have' }} a certificate
            @if (notFound().size) {
              · {{ notFound().size }} {{ notFound().size === 1 ? 'VIN' : 'VINs' }} not found
            }
          </span>
        }
      </div>
      <div class="left">
        @if (selectedIds().size) {
          <span class="selected-count">{{ selectedIds().size }} selected</span>
        }
        <!-- The tooltip sits on a wrapper: a disabled button gets no hover
             events, and the hint matters most while it's disabled. -->
        <span
          [matTooltip]="selectedIds().size < minBulkSelection
            ? 'Select ' + minBulkSelection + ' or more to have them emailed — open a single certificate from its Status link'
            : 'Certificates are emailed to ' + auth.email()">
          <button
            mat-flat-button color="primary"
            [disabled]="!canEmail()"
            (click)="emailCertificates()">
            <mat-icon>download</mat-icon>
            Download Certificates
          </button>
        </span>
      </div>
    </mat-toolbar>

    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="table-scroll">
      <table class="vin-lookup-table" mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              aria-label="Select all certificates"
              [checked]="allSelected()"
              [indeterminate]="someSelected()"
              [disabled]="!selectable().length"
              (change)="toggleAll()" />
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              [attr.aria-label]="'Select certificate for ' + row.vinCode"
              [checked]="isSelected(row)"
              [disabled]="!row.certificateLink"
              (change)="toggle(row)" />
          </td>
        </ng-container>

        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef>Timestamp</th>
          <td mat-cell *matCellDef="let row">{{ formatDateTime(row.timestamp) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            @if (row.certificateLink) {
              <a [href]="row.certificateLink" target="_blank" rel="noopener noreferrer">
                <button mat-button>
                  <span>{{ row.status }}</span>
                  <mat-icon iconPositionEnd>open_in_new</mat-icon>
                </button>
              </a>
            } @else {
              {{ row.status }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="vinCode">
          <th mat-header-cell *matHeaderCellDef>VIN Code</th>
          <td mat-cell *matCellDef="let row"><span class="vin-value">{{ row.vinCode }}</span></td>
        </ng-container>

        <ng-container matColumnDef="decodedMake">
          <th mat-header-cell *matHeaderCellDef>Decoded Make</th>
          <td mat-cell *matCellDef="let row">{{ row.decodedMake }}</td>
        </ng-container>

        <ng-container matColumnDef="decodedModel">
          <th mat-header-cell *matHeaderCellDef>Decoded Model</th>
          <td mat-cell *matCellDef="let row">{{ row.decodedModel }}</td>
        </ng-container>

        <ng-container matColumnDef="decodedYear">
          <th mat-header-cell *matHeaderCellDef>Decoded Year</th>
          <td mat-cell *matCellDef="let row">{{ row.decodedYear }}</td>
        </ng-container>

        <ng-container matColumnDef="processorSite">
          <th mat-header-cell *matHeaderCellDef>Processor Site</th>
          <td mat-cell *matCellDef="let row">{{ row.processorSite }}</td>
        </ng-container>

        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef>User Name</th>
          <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
        </ng-container>

        <ng-container matColumnDef="emailID">
          <th mat-header-cell *matHeaderCellDef>Email ID</th>
          <td mat-cell *matCellDef="let row">{{ row.emailID }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.row-muted]="!row.certificateLink"
            [class.row-selected]="isSelected(row)"></tr>

        <tr class="no-data-row" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length">
            {{ loading() ? '' : 'No processed vehicles match these VINs in this date range.' }}
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"></mat-paginator>
  </mat-card>
}
